import { defaultDirection, userStorageKey } from "../constants/defaultValues";
import exportFromJSON from "export-from-json";

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}/${mm}/${yyyy}`;
};

export const obterDataUmAnoAtras = () => {
  const data = new Date();
  data.setFullYear(data.getFullYear() - 1);
  return getDateISOFormat(data);
}

export const obterDataUmMesAtras = () => {
  const data = new Date();
  data.setMonth(data.getMonth() - 1);
  return getDateISOFormat(data);
}

export const getDateISOFormat = (date) => {
  if (!date) return null;
  const d = new Date(date);
  return d.toISOString().split("T")[0];
}

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem("direction")) {
    const localValue = localStorage.getItem("direction");
    if (localValue === "rtl" || localValue === "ltr") {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === "rtl",
  };
};

export const setDirection = (localValue) => {
  let direction = "ltr";
  if (localValue === "rtl" || localValue === "ltr") {
    direction = localValue;
  }
  localStorage.setItem("direction", direction);
};

export const getDateHourStringBR = (value) => {
  if (!value) return "";

  var splitValue = value.split("T");

  var date = getDateStringBR(value);
  var arrayHour = splitValue[1].split(".");

  return `${date} ${arrayHour[0]}`;
};

export const getDateReference = (value) => {
  if (!value) return "";

  var date = getDateStringBR(value);

  const months = "Null_Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
    "_"
  );
  var dateSplit = date.split("/");

  return `${months[parseInt(dateSplit[1])]}/${dateSplit[2]}`;
};

export const getDateStringBR = (value) => {
  if (!value) return "";

  var arrayDate = value.split("T")[0].split("-");
  var date = new Date(arrayDate[0], arrayDate[1] - 1, arrayDate[2]);

  return new Intl.DateTimeFormat("pt-BR").format(date);
};

export const getDataStringEUA = (data) => {
  var dia = data.split("/")[0];
  var mes = data.split("/")[1];
  var ano = data.split("/")[2];

  return ano + '-' + ("0" + mes).slice(-2) + '-' + ("0" + dia).slice(-2);
}

function treatAsUTC(date) {
  var result = new Date(date);
  result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
  return result;
}
export const getDaysBetween = (startDate, endDate) => {
  var millisecondsPerDay = 24 * 60 * 60 * 1000;
  return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
}

export const getMoney = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value || 0);
};

export const getPercent = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "percent",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value / 100);
};

export const getCPF = (value) => {
  if (!value) return "";

  const pad = "00000000000";

  let numeros = parseInt(value.toString().replace(/[^\d]/g, "")) + "";
  numeros = pad.substring(0, pad.length - numeros.length) + numeros;
  return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
};

export const getIniciasNome = (value) => {
  if (!value) return null;

  let nomes = value.split(" ");

  if (nomes.length <= 1) return nomes[0].substr(0, 2);

  return nomes[0].substr(0, 1) + nomes[1].substr(0, 1);
};

export const fileGenerate = (values, name, type) => {
  const data = values;
  const fileName = name;
  const exportType = type;

  exportFromJSON({ data, fileName, exportType });
};

export const getBooleanFromString = (value) => {
  if (!value || value === 'N')
    return false;
  if (value === 'S')
    return true;
};

export const getNumbers = (value) =>
  value ? value.toString().replace(/[^0-9]/g, "") : "";

export const getValueNumber = (value) => {
  return Number(getNumbers(value));
};


export const getDataURIToBlob = (base64) => {
  const splitDataURI = base64.split(',');
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++)
    ia[i] = byteString.charCodeAt(i)

  return new Blob([ia], { type: mimeString })
};

export function TryParseUserStorage() {
  try {
    return JSON.parse(localStorage.getItem(userStorageKey));
  }
  catch {
    return null;
  }
}

export const TIPOREQUERENTE = {
  ASSOCIADO: 1,
  HERDEIRO: 2,
  CURADOR: 3
}

export const normalizeStr = (str) => {
  if (!str) return '';
  return str
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
};